import { styled } from "@mui/material/styles";
import { Button, Typography } from "@mui/material";
import { ReactComponent as GreaterThanIcon } from "../../loginImages/greater-than.svg";

const SubmitButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  padding: '10px 16px',
  margin: theme.spacing(1, 0, 1),
  width: 'auto',
  minHeight: theme.spacing(5),
}));

const LinkArrow = styled(GreaterThanIcon)(({ theme }) => ({
  marginLeft: theme.spacing(2.5),
  height: '14px',
  width: '14px',
  flexShrink: 0,
}));


interface ButtonInputProps {
  id: string;
  text: string;
  dataTestId?: string;
  onClick?: (state) => void;
  color?: string;
  hoverColor?: string;
  isDisabled?: boolean;
  fullWidth?: boolean;
}

const PrimaryButton = ({
  id,
  text,
  dataTestId,
  onClick,
  color,
  hoverColor,
  isDisabled = false,
  fullWidth = true,
}: ButtonInputProps) => {
  return (
    <SubmitButton
      id={id}
      fullWidth
      variant="contained"
      data-testid={dataTestId}
      type="submit"
      onClick={!isDisabled ? onClick : undefined}
      sx={(theme) => ({
        textTransform: 'none',
        ...(color && {
          backgroundColor: color,
          color: theme.palette.secondary.contrastText,
          '&:hover': {
            backgroundColor: hoverColor ?? color,
          },
        }),
        ...(isDisabled && {
          backgroundColor: theme.palette.action.disabledBackground,
          color: theme.palette.action.disabled,
          '&:hover': {
            backgroundColor: theme.palette.action.disabledBackground,
          },
        }),
        ...(fullWidth && {
          [theme.breakpoints.down('sm')]: {
            width: '100%',
            maxWidth: 'none',
          },
        }),
      })}
    >
      <Typography component="h3" variant="h6" fontWeight="600">
        {text}
      </Typography>
      <LinkArrow
        id="linkArrow"
        sx={(theme) => ({
          ...(color && {
            color: theme.palette.secondary.contrastText
          }),
        })} />
    </SubmitButton>
  );
};

export default PrimaryButton;